<script setup>
import { ref } from 'vue'
import HeaderPanel from '@/components/HeaderPanel.vue'
import WisdomBasePage from './WisdomBasePage.vue'
import WisdomAdminPage from './WisdomAdminPage.vue'

const bases = [
  { label: 'Старая база', value: 'old' },
  { label: 'Новая база', value: 'new' }
]

const selected = ref('new')
</script>

<template>
  <HeaderPanel />
  <WisdomBasePage v-if="selected === 'old'" :hide-header="true">
    <template #header-actions>
      <SelectButton
        v-model="selected"
        :options="bases"
        optionLabel="label"
        optionValue="value"
        :allowEmpty="false"
      />
    </template>
  </WisdomBasePage>
  <WisdomAdminPage v-else :hide-header="true">
    <template #header-actions>
      <SelectButton
        v-model="selected"
        :options="bases"
        optionLabel="label"
        optionValue="value"
        :allowEmpty="false"
      />
    </template>
  </WisdomAdminPage>
</template>
